<template>
  <div class="consolidate-page">
    <div class="page-header">
      <h2>复习</h2>
      <p>回顾薄弱知识点，巩固已学内容</p>
    </div>
    <div class="page-empty">
      <i class="fa fa-refresh"></i>
      <p>复习内容即将上线</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudentReview'
}
</script>

<style lang="less" scoped>
.consolidate-page {
  padding: 32px 40px;
  min-height: 100%;
  box-sizing: border-box;
  background: #f7f8fa;
}

.page-header {
  margin-bottom: 28px;

  h2 {
    margin: 0 0 8px;
    font-size: 22px;
    font-weight: 600;
    color: #1f2329;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #8a8f98;
  }
}

.page-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  color: #8a8f98;

  i {
    font-size: 42px;
    margin-bottom: 16px;
    color: #c4c7c5;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
}
</style>
